import { Dictionary } from '@reduxjs/toolkit';
import { Profile } from 'src/services/apiService/response-models';

export class ProfileCloneHelper {
  static hash: Dictionary<Profile> = {};
}
